var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 15C18.3954 15 17.5 14.1045 17.5 12.9999C17.5 11.8953 18.3954 10.9998 19.5 10.9998C20.6046 10.9998 21.5 11.8954 21.5 12.9999C21.5 14.1045 20.6046 15 19.5 15ZM12.5 15C11.3954 15 10.5 14.1045 10.5 12.9999C10.5 11.8953 11.3954 10.9998 12.5 10.9998C13.6046 10.9998 14.5 11.8953 14.5 12.9999C14.5 14.1045 13.6046 15 12.5 15ZM3.5 12.9999C3.5 14.1045 4.39543 15 5.5 15C6.60457 15 7.5 14.1045 7.5 12.9999C7.5 11.8953 6.60457 10.9998 5.5 10.9998C4.39543 10.9998 3.5 11.8953 3.5 12.9999Z",
    fill: "#9798A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.8cef25b1446912de736a7eb2ff261304.svg";
export { ForwardRef as ReactComponent };